export default "__VITE_ASSET__DxO1Vl7c__"